export default {
  header: 'How many stamps do you have on your stamp card?',
  buttons: {
    continue: 'Continue',
  },
  error_codes: {
    default: 'Something unexpected happened. Please try again or check your internet connection.',
  },
};
